namespace Matrix.Dashboards {
    export interface DataSourceExtractParametersResponse extends Serenity.ServiceResponse {
        Parameters?: Data.DataParameter[];
    }
}
